export const MPS_ADDRESS = '서울 금천구 가산디지털1로 75-24 아이에스비즈타워 10층';
export const MPS_ADDRESS_EN = 'KR 08589 10F, 75-24, Gasan digital 1-ro, Geumcheon-gu, Seoul, Korea';
export const MPS_ADDRESS_ENEN = '3-8 Apple Vly, Irvine CA 92602';
export const MPS_ADDRESS_JP = '〒08589 10F, 75-24, Gasan digital 1-ro, Geumcheon-gu, Seoul, Korea';
export const MPS_MAIL_ORDER_SALES = '2021-서울금천-1710';
export const NBOX_MAIL_ORDER_SALES = '제2013-경기성남-1659호';
